
import { Injectable } from '@angular/core';
import { RestConnService, DsconfigService } from '@services/services.module';

@Injectable()
export class RecognitionService {
  private lock: Object;
  private unlock: Object;
  private status: Object;
  private recognition: Object;
  private recognitionData: Object;
  private recognitionProject: Object;
  private recognitionCalendar: Object;

  constructor(
    private dsConfig: DsconfigService,
    private _res: RestConnService,
  ) {
      this.lock = {
        'lock': dsConfig.getUrlBase() + '/ess/v1/recognition/lock'
      };

      this.unlock = {
        'unlock': dsConfig.getUrlBase() + '/ess/v1/recognition/unlock'
      };
      this.status = {
        'status':  dsConfig.getUrlBase() + '/ess/v1/recognition/calendar'
      };
      this.recognition = {
        'recognition':  dsConfig.getUrlBase() + '/ess/v1/recognition'
      };
      this.recognitionData = {
        'recognitionData':  dsConfig.getUrlBase() + '/ess/v1/recognition'
      };
      this.recognitionProject = {
        'recognitionProject': dsConfig.getUrlBase() + '/ess/v1/recognition/project'
      };
      this.recognitionCalendar = {
        'recognitionCalendar': dsConfig.getUrlBase() + '/ess/v1/recognition/calendar/all'
      };
  }

  loockMonth(data: { month: number, year: number }) {
    return this._res.put('lock', data, {
      collection: this.lock
    });
  }

  unloockMonth(data: { month: number, year: number }) {
    return this._res.put('unlock', data, {
      collection: this.unlock
    });
  }

  getMonthStatus(data: { year: number }) {
    return this._res.get('status', data, {
      collection: this.status
    });
  }

  getRecognitionCalendar() {
    return this._res.get('recognitionCalendar', {}, {
      collection: this.recognitionCalendar
    });
  }

  getProjectRecognitionData(data: { month: number, year: number, projectId: string }) {
    return this._res.get('recognition', data, {
      collection: this.recognition
    });
  }

  postRecognitionData(data) {
    return this._res.post('recognitionData', data, {
      collection: this.recognitionData
    });
  }

  putRecognitionData(data) {
    return this._res.put('recognitionData', data, {
      collection: this.recognitionData
    });
  }

  getRecognitionProject(data) {
    return this._res.get('recognitionProject', data, {
      collection: this.recognitionProject
    });
  }
}
